import axios, { AxiosError, AxiosResponse } from 'axios'
import { MFirearmAnomalyResolution } from '@Models/client/firearm-anomaly-resolution.model'
import { ICommonQuery, IUpdate } from '@Models/common.model'
import * as Redux from 'redux'
import { ToastServices } from '@Services/toast.service'
import { ClientActionTypes } from '@ClientStores/client.action-types'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'

const ITEMREVIEWS = 'item-reviews'

const setFirearmAnomalyLoading = (payload: boolean) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: ClientActionTypes.SET_FIREARM_ANOMALY_LOADING,
            payload,
        })
    }
}

const setFirearmAnomalyQueries = (payload?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: ClientActionTypes.SET_FIREARM_ANOMALY_QUERIES,
            payload,
        })
    }
}

const getFirearmAnomalies = () => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const params = getState()?.client?.firearmAnomaly?.firearmAnomalyQueries
        APIServices.axiosConfig()

        // dispatch(SharedActions.setClientLoading(true) as any)
        dispatch(setFirearmAnomalyLoading(true) as any)
        axios
            .get(ITEMREVIEWS, { params })
            .then((response: AxiosResponse) => {
                const payload = {
                    data: response?.data?.data?.map(
                        (item: MFirearmAnomalyResolution) =>
                            new MFirearmAnomalyResolution(item)
                    ),
                    metadata: response?.data?.metadata,
                }
                dispatch({
                    type: ClientActionTypes.GET_FIREARM_ANOMALIES,
                    payload,
                })
                dispatch(setFirearmAnomalyLoading(false) as any)
                // dispatch(SharedActions.setClientLoading(false) as any)
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                // dispatch(SharedActions.setClientLoading(false) as any)
                dispatch(setFirearmAnomalyLoading(false) as any)
            })
    }
}

const createFirearmAnomaly = (body?: any) => {
    return (dispatch: Redux.Dispatch) => {
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            axios
                .post(ITEMREVIEWS, body)
                .then((response: AxiosResponse) => {
                    ToastServices.success(
                        'Firearm anomaly & Resolution created'
                    )
                    dispatch(getFirearmAnomalies() as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const updateFirearmAnomaly = (updateBody: IUpdate<any>) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .put(`${ITEMREVIEWS}/${updateBody?.id}`, updateBody?.payload)
                .then((response: AxiosResponse) => {
                    ToastServices.success(
                        'Firearm anomaly & Resolution updated'
                    )
                    dispatch(getFirearmAnomalies() as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const updateFirearmAnomalies = (payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .put(`${ITEMREVIEWS}/bulks`, payload)
                .then((response: AxiosResponse) => {
                    ToastServices.success(
                        'Firearm anomaly & Resolution updated'
                    )
                    dispatch(getFirearmAnomalies() as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const deleteFirearmAnomaly = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${ITEMREVIEWS}/${id}`)
                .then((response: AxiosResponse) => {
                    ToastServices.success(
                        'Firearm anomaly & Resolution deleted'
                    )
                    dispatch(getFirearmAnomalies() as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const getRefGenerated = () => {
    return () => {
        return new Promise((resolve, reject) => {
            APIServices.axiosConfig()
            axios
                .get(`${ITEMREVIEWS}/code`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    reject(errors)
                })
        })
    }
}

const ClientFirearmAnomalyActions = {
    getFirearmAnomalies,
    createFirearmAnomaly,
    updateFirearmAnomaly,
    deleteFirearmAnomaly,
    updateFirearmAnomalies,
    getRefGenerated,
    setFirearmAnomalyLoading,
    setFirearmAnomalyQueries,
}

export default ClientFirearmAnomalyActions
